const getNested = (object, ...keys) => {
  return keys.reduce((key, innerKey) => key && key[innerKey], object);
};

export { getNested };
